// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3G3uy","title":"InfoRow_title__1tH9i"};